import { Button } from '@mui/material'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'
import { ModalDialogWrapper } from '../../components/ModalDialogWrapper'

export const TariffUpgradeDialog = ({ open, handleClose, handleSubmit }) => {
    const { t } = useTranslation()

    return (
        <ModalDialogWrapper
            footerActions={
                <>
                    <Button variant="outlined" fullWidth onClick={handleSubmit}>
                        {t('tariffUpgradeDialog.changeLevel')}
                    </Button>
                    <Button variant="contained" onClick={handleClose} fullWidth>
                        {t('tariffUpgradeDialog.stayOnPro')}
                    </Button>
                </>
            }
            colorSubmitButton="secondary"
            variantCloseButton="contained"
            open={open}
            handleClose={handleClose}
            title={t('tariffUpgradeDialog.title')}>
            <Typography variant="body2">
                {t('tariffUpgradeDialog.description')}
            </Typography>
        </ModalDialogWrapper>
    )
}
